<div class="template-generator">
  <mat-tab-group (selectedTabChange)="onTabChange($event)">
    <mat-tab label="Dynamic Template Editor">
      <div class="tab-content">
        <div class="preview-container">
          <div class="template-controls">
            <label for="slug-select">Choose a Slug: </label>
            <select
              id="slug-select"
              [(ngModel)]="selectedSlugName"
              (change)="onSlugChange($event)"
            >
              @for (slug of savedSlugs; track slug) {
              <option [value]="slug.slug">{{ slug.slug }}</option>
              }
            </select>
            @if (currentSlug) {
            <mat-checkbox
              [(ngModel)]="currentSlug.isDevelopment"
              (change)="updateSlugDevelopment($event)"
            >
              Under udvikling
            </mat-checkbox>
            }
            <button
              mat-flat-button
              (click)="saveSlug()"
              [disabled]="!currentSlug"
            >
              Save Slug
            </button>
            <button mat-flat-button (click)="createNewSlug()">New Slug</button>
          </div>
          <!-- Add template-generator-dynamic with 3 tabs for desktop, tablet, and mobile, in separate mat-tab-groups -->
          <mat-tab-group (selectedTabChange)="onTabChange($event)">
            <mat-tab label="Desktop">
              <app-template-generator-dynamic
                [mode]="1"
                [parentComponent]="this"
              ></app-template-generator-dynamic>
            </mat-tab>
            <mat-tab label="Tablet">
              <app-template-generator-dynamic
                [mode]="2"
                [parentComponent]="this"
              ></app-template-generator-dynamic>
            </mat-tab>
            <mat-tab label="Mobile">
              <app-template-generator-dynamic
                [mode]="3"
                [parentComponent]="this"
              ></app-template-generator-dynamic>
            </mat-tab>
          </mat-tab-group>
        </div>
      </div>
    </mat-tab>
    <mat-tab label="Static Template Editor">
      <div class="tab-content">
        <!-- Existing template editor content -->
        <div class="template-controls">
          <label for="template-select">Choose a Template: </label>
          <select
            id="template-select"
            [(ngModel)]="selectedCustomTemplatesStaticUUID"
          >
            <!-- (change)="getSelectedTemplate(selectedCustomTemplatesStaticUUID)" -->
            @for (template of loadAllTemplatesFromSaved(true); track template) {
            <option [value]="template.uuid">{{ template["name"] }}</option>
            }
          </select>
          <button
            mat-flat-button
            (click)="
              saveTemplate(
                selectedCustomTemplatesStaticUUID
                  ? [selectedCustomTemplatesStaticUUID]
                  : []
              )
            "
            [disabled]="!selectedCustomTemplatesStaticUUID"
          >
            Save
          </button>
          <button mat-flat-button (click)="saveTemplateAsNew(true)">
            Save As New
          </button>
        </div>
        <!-- Add template-generator-static with 3 tabs for desktop, tablet, and mobile, in separate mat-tab-groups -->
        <mat-tab-group (selectedTabChange)="onTabChange($event)">
          <mat-tab label="Desktop">
            <app-template-generator-static
              [mode]="1"
              [parentComponent]="this"
            ></app-template-generator-static>
          </mat-tab>
          <mat-tab label="Tablet">
            <app-template-generator-static
              [mode]="2"
              [parentComponent]="this"
            ></app-template-generator-static>
          </mat-tab>
          <mat-tab label="Mobile">
            <app-template-generator-static
              [mode]="3"
              [parentComponent]="this"
            ></app-template-generator-static>
          </mat-tab>
        </mat-tab-group>
      </div>
    </mat-tab>
    <mat-tab label="Custom Modals">
      <div class="tab-content">
        <app-template-generator-modal
          [templateGeneratorComponent]="this"
        ></app-template-generator-modal>
      </div>
    </mat-tab>
    <mat-tab label="Settings">
      <div class="tab-content">
        <!-- Add settings for the template generator here -->
        <div class="settings-container">
          <h3>Template Settings</h3>
          <!-- Add settings controls here -->
          <button mat-flat-button (click)="router.navigate(['/'])">
            Go to Homepage
          </button>
        </div>
      </div>
    </mat-tab>
  </mat-tab-group>
</div>
